import React from "react";
import { RaisedButton } from "material-ui";
import DeleteIcon from "material-ui/svg-icons/action/delete";

export default class extends React.Component {
  constructor(props) {
    super(props);
  }

  getStyles() {
    return {
      orderablepanel: {
        marginRight: 30,
        marginBottom: 15,
        padding: 20,
        border: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        maxWidth: 370
      }
    };
  }

  render() {
    var styles = this.getStyles();
    return (
      <div style={Object.assign({}, styles.orderablepanel, this.props.style)}>
        <div style={{ flex: 1 }}>{this.props.children}</div>
        <div>
          <RaisedButton
            label="Remove"
            onClick={() => this.props.onDelete(this.props.keyval)}
            style={{ marginTop: 10 }}
          />
          <RaisedButton
            label={this.props.direction === "horizontal" ? "◀" : "▲"}
            style={{ minWidth: 30, marginLeft: 7 }}
            disabled={!this.props.canShiftUp}
            onTouchTap={() => this.props.onShiftPosition(this.props.keyval, -1)}
          />
          <RaisedButton
            label={this.props.direction === "horizontal" ? "▶" : "▼"}
            style={{ minWidth: 30, marginLeft: 7 }}
            disabled={!this.props.canShiftDown}
            onTouchTap={() => this.props.onShiftPosition(this.props.keyval, 1)}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/partials/orderable-panel.jsx